export default "__VITE_ASSET__XJEFKIQq__"